import PropTypes from 'prop-types';
import { MarketingProductLink } from '../../analytics/marketingAnalyticsRuntime';

const PublicFooter = ({ hasSessionHint }) => {
    return (
        <footer className="bg-muted/30 border-t border-border">
            <div className="container mx-auto max-w-6xl px-6 py-8">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-sm text-muted-foreground">
                        © {new Date().getFullYear()} Pinpoint Edu
                    </p>
                    <nav aria-label="Footer" className="flex items-center gap-6 text-sm">
                        <a
                            href="/demo"
                            className="text-muted-foreground hover:text-foreground transition-colors"
                        >
                            Demo
                        </a>
                        {hasSessionHint ? (
                            <MarketingProductLink
                                aria-label="Go to practice"
                                ctaId="footer-practice"
                                path="/practice"
                                className="text-muted-foreground hover:text-foreground transition-colors"
                            >
                                <span className="sm:hidden">Practice</span>
                                <span className="hidden sm:inline">Go to practice</span>
                            </MarketingProductLink>
                        ) : (
                            <MarketingProductLink
                                ctaId="footer-login"
                                path="/login"
                                className="text-muted-foreground hover:text-foreground transition-colors"
                            >
                                Log in
                            </MarketingProductLink>
                        )}
                    </nav>
                </div>
            </div>
        </footer>
    );
};

PublicFooter.propTypes = {
    hasSessionHint: PropTypes.bool,
};

export default PublicFooter;
